<template>
  <div 
    :class="['stats-chart', css]"
  >
    <div 
      v-if="title"
      class="chart-header"
    >
      <h3 class="chart-title">{{ title }}: <strong>{{ total }}</strong></h3>
      <div class="chart-legend"></div>
    </div>
    <div class="chart-content">
      
      <div 
        class="bars-chart"
      >
        <div
          v-for="(stat, index) in stats"
          :key="index"
          :class="['bars-chart-row', {'selectable': (enableSelect || enableMultiSelect)}, {'selected': isInSelectedStats(stat)}]"
          :ref="'bar-' + index"
          @click="enableSelect ? toggleStat(stat) : null"
        >
          <div class="bar-description">
            {{ stat.description }}
          </div>
          <div class="bar-progress">
            <div
              class="bar"
              :style="[{'--bar-width': stat.width + '%'}, {'min-width': this.barsMinWidth}, {'background-color': stat.color}]"
            ></div>
          </div>
          <span class="bar-count" v-if="includeCounts">{{ stat.count }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    data: Array,
    barsMinWidth: String,
    css: {
      type: String,
      default: ''
    },
    relativeToHighestValue: {
      type: Boolean,
      default: true
    },
    includeCounts: {
      type: Boolean,
      default: true
    },
    showTooltips: {
      type: Boolean,
      default: true
    },
    enableSelect: {
      type: Boolean,
      default: false
    },
    enableMultiSelect: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      stats: [],
      selectedStats: [],
      total: 0,
      highestValue: 0,
      tooltip: null
    }
  },

  watch: {
    data: {
      handler(newValue, oldValue) {        
        if (newValue !== oldValue) {
          this.setData()
        }
      }, 
      immediate: true,
      deep: true
    }
  },

  mounted: function() {
    
  },

  methods: {
    setData: function() {
      this.total = 0;
      this.highestValue = 0;

      this.data.forEach((r) => {
        this.total += r[1]

        this.highestValue = r[1] > this.highestValue ? r[1] : this.highestValue;
      })

      this.stats = this.data.map((s) => {
        return {
          description: s[0], 
          count: s[1],
          color: s[2] || '',
          percentage: parseFloat((s[1] / this.total) * 100).toFixed(2),
          width: Math.round(s[1] / (this.relativeToHighestValue ? this.highestValue : this.total) * 100)
        }
      })

      this.$nextTick(() => {
        this.handleTooltips();
      });
    },

    isInSelectedStats: function(stat) {
      return this.selectedStats.includes(stat);
    },

    toggleStat: function(stat) {
      if (!this.enableSelect) return;
      
      if (this.isInSelectedStats(stat)) {
        this.selectedStats = this.selectedStats.filter(r => r !== stat);
      } else {
        if (!this.enableMultiSelect) {
          this.selectedStats = [];
        }

        this.selectedStats.push(stat);
      }

      this.$emit('stats-selection-change', this.selectedStats)
    },

    handleTooltips() {
      if (this.showTooltips) {
        const vm = this;
        
        this.stats.forEach((stat, index) => {
          const bar = this.$refs['bar-' + index];

          const t = new bootstrap.Tooltip(bar[0], {
            title: '<strong>' + stat.count + '</strong> (' + stat.percentage + '%)',
            html: true,
            placement: 'top',
            trigger : 'hover'
          })
        })
      }
    }
  }
}

</script>